module.exports = __webpack_public_path__ + "img/09a-osm-outros-dept-show.c823c0f3.png";